import { render } from "./EtatProduitsDisponibles.vue?vue&type=template&id=6c876969&scoped=true&ts=true"
import script from "./EtatProduitsDisponibles.vue?vue&type=script&lang=ts"
export * from "./EtatProduitsDisponibles.vue?vue&type=script&lang=ts"

import "./EtatProduitsDisponibles.vue?vue&type=style&index=0&id=6c876969&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c876969"]])

export default __exports__